import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { APP_FONT_FAMILY } from "../constants/typography";

const CancelPageContent = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "/";
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ maxWidth: 640, mx: "auto", px: 2, pt: 4, textAlign: "center", fontFamily: APP_FONT_FAMILY }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
        {t("breadcrumb_membership_cancelled")}
      </Typography>
      <Typography sx={{ color: "text.secondary", mb: 1 }}>
        {t("membership_cancel_body")}
      </Typography>
      <Typography sx={{ color: "text.secondary" }}>
        {t("membership_success_redirect")}
      </Typography>
    </Box>
  );
};

const CancelPage = () => <CancelPageContent />;

export default CancelPage;
